import * as React from 'react';
import { inputFormatters } from '@blend/ui-common';
import { FormattedInput } from '@blend/shared-react';
import InputContainer, { InputContainerProps } from '../InputContainer/InputContainer';
import { getIdFromName } from '../inputUtils';

// TODO(UI-5237): considering using percentage input formatters once they are fixed
// can make precision a prop if we want to extend use of this component
const normalize = inputFormatters.NUMBER.generateNormalizeWithPrecision(3);
const format = inputFormatters.NUMBER.generateFormatWithPrecision(3);

class PercentageInput extends React.Component<InputProps, {}> {
  private inputProps: DirectInputProps;
  private inputContainerProps: InputContainerProps;

  render() {
    const { input, placeholder, label, meta } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      placeholder,
      type: 'text',
    };

    this.inputContainerProps = {
      label: label || /* istanbul ignore next */ '',
      prefix: '%',
      identifier: input.name,
      name: input.name,
      error: meta.touched && meta.error,
    };

    return (
      <div className="PercentageInput">
        <InputContainer {...this.inputContainerProps}>
          <FormattedInput {...this.inputProps} normalize={normalize} format={format} />
        </InputContainer>
      </div>
    );
  }
}

export const PercentageInputConfig = {
  component: PercentageInput,
  normalize,
};

export default PercentageInput;
